import { customElement } from "lit/decorators.js";
import { Subheading } from "@/components/subheading";

@customElement("eko-card-title")
export class CardTitle extends Subheading {
  constructor() {
    super();
    this.as = "span";
    this.size = "lg";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-card-title": CardTitle;
  }
}

export default CardTitle;
